const mugVariant = 44438916431981
const pricePerCoffee = 80

const addBtn = document.getElementById("bundleAddCart")

function updateBundle(){

let total = 0

document.querySelectorAll(".qty").forEach(q=>{
total += parseInt(q.innerText)
})

document.getElementById("coffeeCount").innerText = total

let price = total * pricePerCoffee
let discount = 0

if(total >= 6){
discount = window.themeSettings.kit_second_discount;
document.getElementById("discountMsg").innerHTML  = document.getElementById("discountMsg").innerText =
    "<div class='discount'>GANHE " + discount + "% OFF</div>";
}
else if(total >= 4){
discount = window.themeSettings.kit_first_discount;
//document.getElementById("discountMsg").innerText = "GANHE 7% OFF"
document.getElementById("discountMsg").innerHTML  = document.getElementById("discountMsg").innerText =
    "<div class='discount'>GANHE " + discount + "% OFF<div>";
}
else{
document.getElementById("discountMsg").innerText = ""
}

if(discount > 0){
price = price - (price * discount / 100)
}

document.getElementById("bundlePrice").innerText = price.toFixed(2)

// let progress = (total/9)*100
// if(progress>100) progress=100

// document.getElementById("progressFill").style.width = progress+"%"

let progress = ((total - 3) / 6) * 100;

if (progress < 0) progress = 0;
if (progress > 100) progress = 100;

document.getElementById("progressFill").style.width = progress + "%";


/* Enable add to cart after 3 coffees */

if(total >= 3){
addBtn.disabled = false
addBtn.style.opacity = "1"
}else{
addBtn.disabled = true
addBtn.style.opacity = "0.5"
}


/* Highlight steps */

document.querySelectorAll(".step").forEach(step=>{
step.classList.remove("active")
})

if(total >=3){
document.getElementById("step3").classList.add("active")
}

if(total >=6){
document.getElementById("step6").classList.add("active")
}

if(total >=9){
document.getElementById("step9").classList.add("active")
}

}



/* plus buttons */

document.querySelectorAll(".plus").forEach(btn=>{
btn.addEventListener("click",function(){

let qty = this.parentElement.querySelector(".qty")

qty.innerText = parseInt(qty.innerText) + 1

updateBundle()

})
})



/* minus buttons */

document.querySelectorAll(".minus").forEach(btn=>{
btn.addEventListener("click",function(){

let qty = this.parentElement.querySelector(".qty")

let val = parseInt(qty.innerText)

if(val>0){
qty.innerText = val - 1
updateBundle()
}

})
})



/* add to cart */

addBtn.addEventListener("click",function(){

let purchaseType = document.querySelector("input[name='purchaseType']:checked").value

let items=[]
let total=0

document.querySelectorAll(".bundle-product").forEach(el=>{

let qty = parseInt(el.querySelector(".qty").innerText)

if(qty>0){

total += qty

let variantID = purchaseType === "sub"
? el.dataset.sub
: el.dataset.one

items.push({
id: Number(variantID),
quantity: qty
})

}

})


if(purchaseType === "sub" && total >=3){

items.push({
id: mugVariant,
quantity:1
})

}


fetch('/cart/add.js',{

method:'POST',

headers:{
'Content-Type':'application/json'
},

body: JSON.stringify({
items: items
})

})
.then(response=>response.json())
.then(()=>{

window.location="/cart"

})

})



/* initial state */

updateBundle()


document.addEventListener("DOMContentLoaded", function () {
  const subDiv = document.querySelector(".sub_toggle");
  const oneDiv = document.querySelector(".one_toggle");
  const radios = document.querySelectorAll('input[name="purchaseType"]');
    const oneQty = oneDiv.querySelector(".qty");
    const subQty = subDiv.querySelector(".qty");
  // default
  subDiv.style.display = "block";
  oneDiv.style.display = "none";

  radios.forEach(function(radio) {
    radio.addEventListener("change", function () {
      if (this.value === "sub") {
        subDiv.style.display = "block";
        oneDiv.style.display = "none";
        oneQty.innerHTML = 0;
        subQty.innerHTML = 0;
        addBtn.disabled = true
        addBtn.style.opacity = "0.5"
      } else if (this.value === "one") {
        subDiv.style.display = "none";
        oneDiv.style.display = "block";
        subQty.innerHTML = 0;
        oneQty.innerHTML = 0;
        addBtn.disabled = true
addBtn.style.opacity = "0.5"
        
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const labels = document.querySelectorAll(".purchase-box label");

  labels.forEach(label => {
    label.addEventListener("click", function () {

      // remove active class from all
      labels.forEach(l => l.classList.remove("pactive"));

      // add active class to clicked label
      this.classList.add("pactive");

    });
  });
});